import fetchWrapper from '../utils/fetch/fetchWrapper';

const fetchElectricVehicles = async (params) => {
  Object.keys(params).forEach(
    (key) => params[key] == null && delete params[key]
  );

  let url = new URL(`${process.env.REACT_APP_API_HOST}/vehicles`);
  let searchParams = new URLSearchParams(params);

  url.search = searchParams;
  url.search += `&include_used_vehicles`;

  const json = await fetchWrapper(url, {
    method: 'GET',
  });

  if (!json || !json.vehicles) {
    console.error('Invalid API response for electric vehicles:', json);
    return {
      newElectricVehicles: [],
      usedElectricVehicles: [],
    };
  }

  const electricVehicles = json.vehicles;

  return {
    newElectricVehicles: electricVehicles,
  };
};

export default fetchElectricVehicles;
